import { 
	useMutation, 
	useQuery, 
	useQueryClient 
} from 'react-query';

import { 
  ApiError,
	PostUtilityAccountNewAccount, 
	PostUtilityAccountNewAccountResponse,
	UtilityAccount
} from 'src/modules/generated-api-clients/sql';
import { useApiSqlContext } from 'src/modules/contexts/ApiSqlContext';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { QUERY_KEYS_SQL } from './queryKeyEnum';

interface UtilityAccountParams extends UtilityAccount {
	project?: string;
	// skip?: number;
	// limit?: number;
}

//reporting.utility_accounts
// hooks in this file are for reporting.utility_accounts SQL table.
// TODO: why are these using different caches?

// TODO: change this to useListUtilityAccount
// export const useListAccountNumber = () => {
//   const { client } = useApiSqlContext();
// 	return useQuery<any, ApiError>(
// 		['accountInfo'],
// 		async () => {
// 			try {
// 				if (!client) {
// 					throw new Error('API client is not initialized');
// 				}
// 				const response = await client.default.getBackendGetAllAccountNumbers();
// 				return response;
// 			} catch (error: unknown) {
// 				if (error instanceof ApiError) {
// 					console.error(
// 						`ApiError -> URL: ${error.url}\nSTATUS: ${error.status}\nMESSAGE: ${
// 							error.message
// 						}\nBODY: ${JSON.stringify(error.body)}`
// 					);
// 					throw error;
// 				} else {
// 					console.error('Error fetching account information:', error);
// 					throw error;
// 				}
// 			}
// 		},
// 		{}
// 	);
// };

// export const useListUtilityAccount = () => {
// 	const queryClient = useQueryClient();
// 	const { client } = useApiSqlContext();
// 	const { user } = useAuthenticator(context => [context.user]);
// 	const token = user.getSignInUserSession()?.getIdToken().getJwtToken();
// 	return useQuery<UtilityAccount[], ApiError>(
// 		['accountInfo'],
// 		async () => {
// 			try {
// 				if (!client) {
// 					throw new Error('API client is not initialized');
// 				}
// 				if (token === undefined) {
// 					throw new Error('AWS Amplify user attributes cannot be undefined');
// 				}
// 				const response = await client.default.getAdminPortalUtilityAccountListAccounts(token);
// 				return response;
// 			} catch (error: unknown) {
// 				if (error instanceof ApiError) {
// 					console.error(
// 						`ApiError -> URL: ${error.url}\nSTATUS: ${error.status}\nMESSAGE: ${
// 							error.message
// 						}\nBODY: ${JSON.stringify(error.body)}`
// 					);
// 					throw error;
// 				} else {
// 					console.error('Error fetching account information:', error);
// 					throw error;
// 				}
// 			}
// 		},
// 		{}
// 	);
// };

	export const useListUtilityAccount = (params?: UtilityAccountParams) => {
	const { client } = useApiSqlContext();
	const { user } = useAuthenticator(context => [context.user]);
	const token = user.getSignInUserSession()?.getIdToken().getJwtToken();

	const query = async () => {
		try {
			if (!client) {
				throw new Error('API client is not initialized');
			}
			if (token === undefined) {
				throw new Error('AWS Amplify user attributes cannot be undefined');
			}

			const response =
				params === undefined
					? await client.default.getAdminPortalUtilityAccountListAccounts(token)
					: await client.default.getAdminPortalUtilityAccountListAccounts(
							token,
							params.project
						);
			return response as UtilityAccount[];
		} catch (error: unknown) {
			if (error instanceof ApiError) {
				console.error(
					`ApiError -> URL: ${error.url}\nSTATUS: ${error.status}\nMESSAGE: ${
						error.message
					}\nBODY: ${JSON.stringify(error.body)}`
				);
				throw error;
			}
			throw error;
		}
	};
	const data = useQuery<UtilityAccount[], ApiError>(
		[QUERY_KEYS_SQL.utilityAccounts.UtilityAccountsList, params], 
		query 
	);
	return data
};

export const useCreateUtilityAccount = () => {
	const queryClient = useQueryClient();
	const { client } = useApiSqlContext();
	const { user } = useAuthenticator(context => [context.user]);
	const token = user.getSignInUserSession()?.getIdToken().getJwtToken();

	if (!client) {
		throw new Error('useCreateUtilityAccount: useApiSqlContext not initialized');
	}
	return useMutation<PostUtilityAccountNewAccountResponse, ApiError, PostUtilityAccountNewAccount>((
		requestBody: PostUtilityAccountNewAccount
	) => {
			// Guard against errors
			if (!client) {
				throw new Error('API client is not initialized');
			}
			if (token === undefined) {
				throw new Error('AWS Amplify user attributes cannot be undefined');
			}
			return client.default.postAdminPortalUtilityAccountNewAccount(token, requestBody);
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries('utilityFacilities');
				queryClient.invalidateQueries(QUERY_KEYS_SQL.utilityAccounts.UtilityAccountsList);
			},
			onError: (error: unknown) => {
				if (error instanceof ApiError) {
					const msgBody = JSON.stringify(error.body);
					const msg = `ApiError -> URL: ${error.url}\nSTATUS: ${error.status}\nMESSAGE: ${error.message}\nBODY: ${msgBody}`
					console.error(msg);
				} else {
					console.error('Error: ', error);
				}
			}
		}
	);
};